import { ThemeConfig } from 'antd';

// Primary color for Ant Design
export const PRIMARY_COLOR = '#385da4';

// Ant Design theme configuration
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: PRIMARY_COLOR,
    borderRadius: 6,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Button: {
      primaryColor: '#fff',
      borderRadius: 6,
    },
    Card: {
      borderRadius: 8,
    },
    Input: {
      borderRadius: 6,
    },
    Select: {
      borderRadius: 6,
    },
    DatePicker: {
      borderRadius: 6,
    },
    Table: {
      borderRadius: 6,
    },
  },
};

export default antdTheme;

